// Translates Strapi /api/search (flat + meta.pagination) into the nested-array
 // shape Search/index.js already expects: { status, result: Array<Array<item>> }.
export function adaptSearchResults(json, locale = 'en') {
    const items = (json && json.data) || []
    const pageSize = (json && json.meta && json.meta.pagination && json.meta.pagination.pageSize) || 10

    const mapped = items.map(item => {
        const path = item.path || ''
        const withLocale = path.startsWith(`/${locale}/`)
            ? path
            : `/${locale}${path.startsWith('/') ? path : `/${path}`}`

        // Normalize legacy static paths to current frontend routes.
        const link = withLocale
            .replace(`/${locale}/home`, `/${locale}`)
            .replace(`/${locale}/clients`, `/${locale}/our-client`)

        return {
            page: item.title,
            breadcrumbs: [item.type === 'page' ? 'Page' : item.type, item.title].filter(Boolean),
            link,
        }
    })

    const pages = []
    for (let i = 0; i < mapped.length; i += pageSize) {
        pages.push(mapped.slice(i, i + pageSize))
    }

    return {
        status: mapped.length > 0,
        result: pages,
    }
}
